import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { LoadingState } from '@/components/loading/LoadingState';
import { Button } from '@/components/forms';
import { AuthLayout } from '@/components/layout';
import { useSession } from './context';

/**
 * Protege uma rota quando a auth está ligada. Em modo demonstração (server sem banco)
 * a tela abre como antes, com dados mock.
 */
export function RequireAuth({ children, financas = false }: { children: ReactNode; financas?: boolean }) {
  const session = useSession();
  const location = useLocation();
  if (session.status === 'loading') return <LoadingState />;
  if (session.status === 'demo') return <>{children}</>;
  if (!session.viewer) {
    const next = `${location.pathname}${location.search}`;
    return <Navigate to={`/auth?next=${encodeURIComponent(next)}`} replace />;
  }
  if (financas && !session.viewer.canAccessFinancas) {
    return (
      <AuthLayout badge="Acesso restrito">
        <div className="auth-card">
          <h2>Finanças é pessoal</h2>
          <p className="lead">Este módulo usa os dados bancários do titular (Meu Pluggy, uso pessoal) e não está liberado para a sua conta.</p>
          <Button block to="/">Voltar para a visão geral</Button>
        </div>
      </AuthLayout>
    );
  }
  return <>{children}</>;
}

/** Só aceita caminhos internos em `?next=` (evita redirecionar para outro site). */
export const safeNext = (next: string | null) => (next && next.startsWith('/') && !next.startsWith('//') ? next : '/');
